import { Container, CircularProgress } from "@mui/material";
import ItemList from "../../components/ItemList";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const TaskClasses = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fieldsConfig = [
    { key: "uuid", label: "Placeholder", type: "text", displayForm: false, displayList: false },
    { key: "task_class", label: "Tarea", type: "text", required: true, displayForm: true, displayList: true }
  ];

  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Clases de tareas
        </Typography>
      </Box>
      {!isLoading ? (
        <ItemList fields={fieldsConfig} tableName="task_classes" hasCheckbox={true} objectName={"task class"} tabledescription={"Clases de tareas"}/>
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};

export default TaskClasses;
